/**
 * Words for a bundle version written by the portability import (SA-1473): where it came from.
 * Pure. The date is formatted by hand in UTC, never through the viewer's locale.
 */

export interface ImportOrigin {
  source_label: string
  exported_at: string | null
  source_persona: string
  source_version: number | null
  imported_at: string
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

function utcDay(iso: string): string | null {
  const at = new Date(iso)
  if (Number.isNaN(at.getTime())) return null
  return `${at.getUTCDate()} ${MONTHS[at.getUTCMonth()]} ${at.getUTCFullYear()}`
}

export function importOriginLine(
  origin: ImportOrigin | null | undefined,
  importer: string | null | undefined,
): string | null {
  if (!origin) return null
  const label = (origin.source_label ?? '').trim() || 'another environment'
  const version = origin.source_version != null ? ` (v${origin.source_version})` : ''
  const exported = origin.exported_at ? utcDay(origin.exported_at) : null
  const exportedClause = exported ? `, exported ${exported}` : ''
  const by = importer ? `, by ${importer}` : ''
  return `Imported from ${label}${version}${exportedClause}${by}`
}
